import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import { ConfirmProvider } from "./context/ConfirmContext";
import ErrorBoundary from "./ErrorBoundary";
import DocumentPreview from './components/common/DocumentPreview';
import config from "devextreme/core/config";

config({ editorStylingMode: "outlined" });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
});

const AppRoutes = lazy(() => import("./routes/AppRoutes"));

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <NotificationProvider>
            <ConfirmProvider>
              <ErrorBoundary>
                <Router>
                  <DocumentPreview />
                  <Suspense fallback={<div className="loading-screen">Loading application...</div>}>
                    <AppRoutes />
                  </Suspense>
                </Router>
              </ErrorBoundary>
            </ConfirmProvider>
          </NotificationProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
